import React from 'react';
import { Box, Typography } from '@mui/material';
import pxToRem from 'assets/theme/function/px-to-rem';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as BackIcon } from 'assets/images/back-to-asset-icon.svg';

interface Props {
    navigateUrl: string;
}

const BackNavigate: React.FC<Props> = (props: Props) => {
    const { navigateUrl } = props;
    const navigate = useNavigate();

    const handelClickBack = () => {
        navigate(navigateUrl.trim());
    };

    return (
        <>
            <Box
                sx={{
                    width: 'fit-content',
                    cursor: 'pointer',
                }}
                mr={pxToRem(20)}
                display="flex"
                alignItems="center"
                onClick={handelClickBack}
            >
                <BackIcon fontSize="small" />
                <Typography pl={pxToRem(7)} variant="subtitle1">
                    Back
                </Typography>
            </Box>
        </>
    );
};

export default BackNavigate;
